import React from 'react';

import {
    Ability,
    CharacterTheme,
    Constants,
    DataOrigin,
    DeathSaveInfo,
    DiceAdjustment,
    RuleData,
} from '@dndbeyond/character-rules-engine/es';

import DiceAdjustmentSummary from '../../../Shared/components/DiceAdjustmentSummary';

interface Props {
    abilities: Array<Ability>;
    savingThrowDiceAdjustments: Array<DiceAdjustment>;
    onDataOriginClick?: (dataOrigin: DataOrigin) => void;
    deathSaveInfo: DeathSaveInfo;
    ruleData: RuleData;
    theme: CharacterTheme;
}
export default class SavingThrowsDetails extends React.PureComponent<Props> {
    renderDiceAdjustmentList = (
        diceAdjustments: Array<DiceAdjustment>,
        showDataOrigin: boolean = false,
    ): React.ReactNode => {
        const { onDataOriginClick, ruleData, theme } = this.props;

        if (!diceAdjustments.length) {
            return null;
        }

        return (
            <React.Fragment>
                {diceAdjustments.map((diceAdjustment, idx) => {
                    return (
                        <DiceAdjustmentSummary
                            theme={theme}
                            diceAdjustment={diceAdjustment}
                            key={diceAdjustment.uniqueKey}
                            ruleData={ruleData}
                            showDataOrigin={showDataOrigin}
                            onDataOriginClick={onDataOriginClick}
                        />
                    );
                })}
            </React.Fragment>
        );
    };

    render() {
        const { savingThrowDiceAdjustments, deathSaveInfo } = this.props;

        if (
            !savingThrowDiceAdjustments.length &&
            !deathSaveInfo.disadvantageAdjustments.length &&
            !deathSaveInfo.advantageAdjustments.length
        ) {
            return <div className="ct-saving-throws-details__empty">You have no saving throw modifiers</div>;
        }

        const advantageSavingThrowAdjustments: Array<DiceAdjustment> = [];
        const disadvantageSavingThrowAdjustments: Array<DiceAdjustment> = [];
        const bonusSavingThrowAdjustments: Array<DiceAdjustment> = [];

        savingThrowDiceAdjustments.forEach((adjustment) => {
            if (adjustment.type === Constants.DiceAdjustmentTypeEnum.ADVANTAGE) {
                advantageSavingThrowAdjustments.push(adjustment);
            }
            if (adjustment.type === Constants.DiceAdjustmentTypeEnum.DISADVANTAGE) {
                disadvantageSavingThrowAdjustments.push(adjustment);
            }
            if (adjustment.type === Constants.DiceAdjustmentTypeEnum.BONUS) {
                bonusSavingThrowAdjustments.push(adjustment);
            }
        });

        return (
            <div className="ct-saving-throws-details">
                {this.renderDiceAdjustmentList(advantageSavingThrowAdjustments)}
                {this.renderDiceAdjustmentList(deathSaveInfo.advantageAdjustments)}
                {this.renderDiceAdjustmentList(disadvantageSavingThrowAdjustments)}
                {this.renderDiceAdjustmentList(deathSaveInfo.disadvantageAdjustments)}
                {this.renderDiceAdjustmentList(bonusSavingThrowAdjustments, true)}
            </div>
        );
    }
}
